import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';
import { areResultsOwnedByUser } from 'selectors';
import highlightingService from 'services/highlightingService';

import DNACategory from './DNACategory';
import DNADatumPopover from './DNADatumPopover';
import { screenService } from 'frontend-component-library';

class DNADatum extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      infoOpen: false,
    };
  }

  openRecommendation = () => {
    highlightingService.highlightRecommendation(this.props.recommendation);
    this.setState({ infoOpen: true });
  };

  closeRecommendation = event => {
    const { recommendation, removeRecommendationFromList } = this.props;
    highlightingService.resetHighlighting(event);
    this.setState({ infoOpen: false });
    if (recommendation.is_hidden) {
      removeRecommendationFromList(recommendation.uuid);
    }
  };

  handleClick = () => {
    if (screenService.isTouchDevice() && !this.state.infoOpen) {
      this.openRecommendation();
    }
  };

  renderCategories = () => {
    const { datumIsDimmed, recommendation: { tags } } = this.props;
    return tags
      .filter(tag => tag.schema === 'categories')
      .map((category, i) => {
        return (
          <DNACategory
            key={i}
            isActive={this.state.infoOpen}
            tagInfo={category}
            datumIsDimmed={datumIsDimmed}
          />
        );
      });
  };

  render() {
    const { recommendation: { uuid } } = this.props;
    return (
      <div
        className="DNADatum"
        data-id={uuid}
        ref={node => (this.node = node)}
        onClick={this.handleClick}
        onMouseEnter={this.openRecommendation}
        onMouseLeave={this.closeRecommendation}
      >
        {this.renderCategories()}
        <DNADatumPopover
          showCloseButton={screenService.isTouchDevice()}
          closePopover={this.closeRecommendation}
          parentNode={this.node}
          recommendation={this.props.recommendation}
          isOpen={this.state.infoOpen}
          areResultsOwnedByUser={this.props.areResultsOwnedByUser}
        />
      </div>
    );
  }
}

DNADatum.propTypes = {
  recommendation: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  return {
    areResultsOwnedByUser: areResultsOwnedByUser(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      removeRecommendationFromList: actions.removeRecommendationFromList,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DNADatum);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/DNAGraph/DNADatum.js